module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    attrs: {
      "justify-start": ""
    }
  }, [_c('span', [_c('router-link', {
    attrs: {
      "to": {
        name: 'Проекты'
      }
    }
  }, [_vm._v("Проекты")])], 1), _vm._v(" "), _c('span', [_vm._v("/"), _c('b', [_vm._v(" Вопросы и ответы ")])]), _vm._v(" "), _c('v-divider', {
    staticClass: "mt-3"
  }), _vm._v(" "), _c('h2', [_vm._v(" Частые вопросы и ответы ")])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-10e5449a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/faq.vue
// module id = 460
// module chunks = 1